function placeholder (node) {
  const rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

  [].slice.call(node.querySelectorAll('.form-field:not(.form-field--not-input)')).forEach(function (inputEl) {
    if (inputEl.closest('.form-item-wrap')) {
      if (inputEl.value.replace(rtrim, '') !== '') {
        inputEl.closest('.form-item-wrap').classList.add('input--filled');
        inputEl.closest('.form-item-wrap').classList.add('input--focus');
      }

      inputEl.addEventListener('change', () => {
        if (inputEl.value.replace(rtrim, '') !== '') {
          inputEl.closest('.form-item-wrap').classList.add('input--filled');
        }
      });

      inputEl.addEventListener('focus', onInputFocus);
      inputEl.addEventListener('blur', onInputBlur);
    }
  });

  function onInputFocus (ev) {
    if (ev.target.closest('.form-item-wrap')) {
      ev.target.closest('.form-item-wrap').classList.add('input--focus');
    }
  }

  function onInputBlur (ev) {
    if (ev.target.closest('.form-item-wrap')) {
      ev.target.closest('.form-item-wrap').classList.remove('input--focus');
      if (ev.target.value.replace(rtrim, '') === '') {
        ev.target.closest('.form-item-wrap').classList.remove('input--filled');
      }
    }
  }
}

placeholder(document);

const clearInput = document.querySelectorAll('.js-input-clear');

if (clearInput.length) {
  [...clearInput].forEach(item => {
    item.addEventListener('click', () => {
      if (item.closest('.form-field-wrap')) {
        const field = item.closest('.form-field-wrap').querySelector('.form-field');
        field.value = '';
        item.closest('.form-field-wrap').classList.remove('input--filled');
        item.closest('.form-field-wrap').classList.remove('input--focus');
      }
    });
  });
}

export { placeholder };
